// Order of imports matters in that file so sorting imports disabled
/* eslint-disable import/first */
/* eslint-disable simple-import-sort/imports */

// // Media files
// Polyfills
import 'babel-polyfill'
import 'core-js/features/url'
import 'core-js/features/url-search-params'
import 'modernizr'
import '../src/polyfill/foreach'

// // Media files
require.context('../pdf', true)
require.context('../images', true)

// Libraries (jQuery)
import 'select2/dist/js/select2.full'

// React components
import '../components/initComponents'

// Our JavaScript
import '../src/selectVrBanken'
import '../src/actionCable/subscribeToDownloadChannel'
import '../src/registrationForm'
import '../src/passwordVisibility'

document.addEventListener('click', event => {
  const isButton = event.target.matches('button')
  const isAnchor = event.target.matches('a')

  if (isButton || isAnchor) {
    event.target.focus()
  }
})
